import { render, staticRenderFns } from "./ColorTemperatureHelp.vue?vue&type=template&id=4c31eca1"
import script from "./ColorTemperatureHelp.vue?vue&type=script&lang=js"
export * from "./ColorTemperatureHelp.vue?vue&type=script&lang=js"
import style0 from "./ColorTemperatureHelp.vue?vue&type=style&index=0&id=4c31eca1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorTemperatureScale: require('/app/components/ColorTemperatureScale.vue').default})
